const state = () => ({
    imports: [],
    importStatuses: [],
    isOverviewPageLoading: true,
    selectedFilter: String,
});

const getters = {};

const actions = {};

const mutations = {
    setImports(state, val) {
        state.imports = val;
    },
    togglePageLoadingStatus(state, val) {
        state.isOverviewPageLoading = val;
    },
    setImportStatuses(state, val) {
        state.importStatuses = val;
    },
    applySelectedFilter(state, val) {
        state.selectedFilter = val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
